class Resizing {
    constructor() {
        this.resizeTimer = null;
        this.resizeInterval = 50;

        this.scrollbarMeasureTimer = null;
    }

    setup() {
        const rHandler = global.utils.throttled(this.resizeInterval, this.resizeHandler);
        if(window.attachEvent) {
            window.attachEvent('onresize', rHandler);
        }else if(window.addEventListener) {
            window.addEventListener('resize', rHandler, true);
        }else {
            //The browser does not support Javascript event binding
            window.onresize = rHandler;
        }

        this.resizeHandler();
    }

    onResize(c, t) {
        onresize = function() {
            clearTimeout(t);
            t = setTimeout(c, 100);
        };
        return c;
    }

    resizeHandler() {
        global.utils.updateSizeRefs();
        console.log(global.viewportWidth + " x " + global.viewportHeight);
        $('.resolution').html(global.viewportWidth + " x " + global.viewportHeight);

        /*if(this.scrollbarMeasureTimer !== undefined){
            clearTimeout(this.scrollbarMeasureTimer);
        }
        this.scrollbarMeasureTimer = setTimeout(global.utils.measureScrollBarWidth, this.resizeInterval*2);
        */

        if(global.viewportHeight <= 400){
            $('html').addClass('vp-short');
        }else{
            $('html').removeClass('vp-short');
        }
    }

}

module.exports = { Resizing };
